<app-wrapper-layout>
<app-header-layout [userLogin]="userLogin"> </app-header-layout>
<div class="sign-up">
  <div class="sign-up__header">
    <h1>Unrivaled Fishing Intel</h1>
    <span>Cast with confidence and join over 1 million other anglers already having more success on the water</span>
  </div>
  <div class="sign-up__rectangle">
    <div class="sign-up__data" fxFlex="100" fxLayout="row">
      <div class="col-md-6 sign-up__free">
        <div class="sign-up__free-data">
          <div class="sign-up__free-checkbox">
            <div class="free-checkbox">
              <input type="checkbox" value="None" id="free-checkbox" name="check" checked disabled />
              <label for="free-checkbox"></label>
            </div>
          </div>
          <span>Exact locations on map</span>
        </div>
        <div class="sign-up__free-data">
          <div class="sign-up__free-checkbox">
            <div class="free-checkbox">
              <input type="checkbox" value="None" id="free-checkbox" name="check" checked />
              <label for="free-checkbox"></label>
            </div>
          </div>
          <span>Mapped depth contours</span>
        </div>
        <div class="sign-up__free-data">
          <div class="sign-up__free-checkbox">
            <div class="free-checkbox">
              <input type="checkbox" value="None" id="free-checkbox" name="check" checked />
              <label for="free-checkbox"></label>
            </div>
          </div>
          <span>Detailed fishery info</span>
        </div>
      </div>
      <div class="col-md-6 sign-up__premium">
        <div class="sign-up__premium-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked disabled />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Exact locations on map</span>
        </div>
        <div class="sign-up__premium-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Mapped depth contours</span>
        </div>
        <div class="sign-up__premium-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Detailed fishery info</span>
        </div>
        <div class="sign-up__premium-special-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Fishing Hot Spots & Tips</span>
        </div>
        <div class="sign-up__premium-special-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Underwater Structure & Habitat</span>
        </div>
        <div class="sign-up__premium-special-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Enhanced Fishing Forecaster (mobile only)</span>
        </div>
        <div class="sign-up__premium-special-data">
          <div class="sign-up__premium-checkbox">
            <div class="premium-checkbox">
              <input type="checkbox" value="None" id="premium-checkbox" name="check" checked />
              <label for="premium-checkbox"></label>
            </div>
          </div>
          <span>Offline Mapping</span>
        </div>
        <div class="sign-up__waterway" (click)="navigateWaterway()">
          <span>See if we have premium layers on your waterway</span>
          <mat-icon svgIcon="iconNext"></mat-icon>
        </div>
      </div>
    </div>
    <div class="sign-up__bottom" fxFlex="100" fxLayout="row">
      <div class="sign-up__button-free col-md-6 col-sm-6">
        <app-button [inheritFontSize]="true" (click)="navigateSignupFree()">
          <span>Sign up free</span>
        </app-button>
      </div>
      <div class="sign-up__button-premium col-md-6 col-sm-6">
        <app-button [inheritFontSize]="true" (click)="navigateSignupPremium()">
          <span>Go Premium</span>
        </app-button>
        <div class="sign-up__billed">
          <div class="sign-up__billed-annually">
            <span class="sign-up__billed-annually__unit">$4.17 </span>
            <span class="sign-up__billed-annually__time">/mo</span>
            <div class="sign-up__billed-annually__description">
              <p>$49.99 </p>
              <p class="sign-up__billed-annually__description__unit"> Billed annually</p>
            </div>
          </div>
          <div class="sign-up__billed-monthly">
            <span class="sign-up__billed-monthly__unit">$9.99 </span>
            <span class="sign-up__billed-monthly__time">/mo</span>
            <p class="sign-up__billed-monthly__description">Billed monthly</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</app-wrapper-layout>